import { DateTime } from 'luxon'

export enum EvRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  OPERATOR = 'operator',
  FIELD_OPERATOR = 'field_operator',
  VIEWER = 'viewer',
  EV_STATISTICS_VIEWER = 'statistics-viewer',
  EV_CAR_OWNER = 'ev_car_owner',
}

export enum EvStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface EvAdmin {
  id: string
  email: string
  ev_role?: EvRole
  ev_status?: EvStatus
  role: string // P2P role
  status: string // P2P status
  createdAt: DateTime
  updatedAt: DateTime
}

export interface CreateEvAdminAccount {
  email: string
  ev_role: EvRole
}
